<template>
  <div class="create-visit-form__form--wrapper">
    <form @submit.prevent="submitForm($event)" class="create-visit-form__form" method="POST">
      <div v-for="field in fields" :key="field.id" class="create-visit-form__field" :class="field.width">
        <input-field v-if="field.type == 'text' || field.type == 'date' || field.type == 'email'" :field="field" />
        <text-area-field v-else-if="field.type == 'textarea'" :field="field"/>
        <select-field v-else-if="field.type == 'select'" :field="field" />
        <upload-field v-else-if="field.type == 'upload'" :field="field" />
        <checkbox-field v-else-if="field.type == 'checkbox'" :field="field" />
      </div>
      <button type="submit">
        <span v-if="formType == 'registrerabesok'" v-html="locationSvg"></span>
        <span v-else v-html="arrowSvg"></span>
        <span v-if="formType == 'registrerabesok'">Registrera ditt besök</span>
        <span v-else>Skicka</span>
      </button>
    </form>
    <div v-if="showMessage" aria-live="polite" class="create-visit-form__message" :class="message.success ? 'success' : 'error'">
      <p>{{ message.message }}</p>
    </div>
    <div v-if="loading" class="create-visit-form__loader">
      <div class="lds-ring">
        <span class="show-for-sr">Laddar...</span>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from './components/InputField.vue';
import TextAreaField from './components/TextAreaField.vue';
import SelectField from './components/SelectField.vue';
import UploadField from './components/UploadField.vue';
import CheckboxField from './components/CheckboxField.vue';

export default {
  name: 'App-template',
  computed: {
    fields() {
      return this.$store.state.fields;
    },
    message() {
      return this.$store.state.message;
    },
    showMessage() {
      return this.$store.state.showMessage;
    },
    loading() {
      return this.$store.state.loading;
    },
    formType(){
      return this.$store.state.formType;
    },
    locationSvg() {
      return this.$store.state.locationSvg;
    },
    arrowSvg() {
      return this.$store.state.arrowSvg;
    }
  },
  methods: {
    submitForm(e) {
      const formData = new FormData(e.target);
      this.$store.dispatch('submitForm', formData)
    }
  },
  components: {
    InputField,
    TextAreaField,
    SelectField,
    UploadField,
    CheckboxField
  }
}
</script>
